import React, { useEffect } from 'react';
import '../CSS/WhyChooseUs.css';

const WhyChooseUs = () => {
  useEffect(() => {
    document.title = 'Why Choose MuscleCrete | PAC Corporation';
    document.querySelector('meta[name="description"]').setAttribute(
      'content',
      'Discover why MuscleCrete is the premium choice for concrete coatings, tile adhesives, and grouts with ISO certifications and proven quality.'
    );
  }, []);

  const benefits = [
    {
      id: 1,
      title: 'Premium Quality',
      description: 'ISO 9001-2015 certified products with rigorous quality control at every manufacturing stage.',
      icon: '⭐'
    },
    {
      id: 2,
      title: 'International Standards',
      description: 'CE Certified products meeting European quality standards for safety and performance.',
      icon: '🏆'
    },
    {
      id: 3,
      title: 'Proven Durability',
      description: 'Products engineered to withstand harsh environmental conditions and heavy usage.',
      icon: '💪'
    },
    {
      id: 4,
      title: 'Expert Support',
      description: 'Dedicated technical team ready to provide guidance on product selection and application.',
      icon: '👥'
    },
    {
      id: 5,
      title: 'Made in India',
      description: 'Proudly manufactured with cutting-edge technology and rigorous quality standards.',
      icon: '🇮🇳'
    },
    {
      id: 6,
      title: 'Competitive Pricing',
      description: 'Premium quality at competitive prices without compromising on excellence.',
      icon: '💰'
    }
  ];

  const comparison = [
    {
      feature: 'Quality Certification',
      musclecrete: 'ISO 9001-2015 & CE Certified',
      others: 'Basic or No Certification'
    },
    {
      feature: 'Product Range',
      musclecrete: '15+ Premium Products',
      others: '5-8 Standard Products'
    },
    {
      feature: 'Technical Support',
      musclecrete: '24/7 Expert Support',
      others: 'Limited Support'
    },
    {
      feature: 'Durability',
      musclecrete: '10+ Years Performance',
      others: '3-5 Years'
    },
    {
      feature: 'Environmental Compliance',
      musclecrete: 'Eco-Friendly Formulations',
      others: 'Standard Formula'
    }
  ];

  return (
    <main className="why-choose-us-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <h1 className="hero-title">Why Choose MuscleCrete</h1>
          <p className="hero-subtitle">
            Experience the premium choice in concrete coatings, tile adhesives, and grouts
          </p>
        </div>
      </section>

      {/* Benefits Grid */}
      <section className="benefits-section">
        <div className="container">
          <h2 className="section-title">Our Advantages</h2>
          <div className="benefits-grid">
            {benefits.map(benefit => (
              <div key={benefit.id} className="benefit-card">
                <div className="benefit-icon">{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Comparison Section */}
      <section className="comparison-section">
        <div className="container">
          <h2 className="section-title">MuscleCrete vs Others</h2>
          <div className="comparison-table-wrapper">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>MuscleCrete</th>
                  <th>Other Brands</th>
                </tr>
              </thead>
              <tbody>
                {comparison.map((row, idx) => (
                  <tr key={idx}>
                    <td className="feature-name">{row.feature}</td>
                    <td className="musclecrete-column">
                      <span className="checkmark">✓</span> {row.musclecrete}
                    </td>
                    <td className="others-column">{row.others}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Certifications Section */}
      <section className="certifications-section">
        <div className="container">
          <h2 className="section-title">Our Certifications & Standards</h2>
          <div className="certifications-grid">
            <div className="certification-card">
              <div className="cert-badge">ISO</div>
              <h3>ISO 9001-2015</h3>
              <p>Quality Management System</p>
            </div>
            <div className="certification-card">
              <div className="cert-badge">CE</div>
              <h3>CE Certified</h3>
              <p>European Conformity</p>
            </div>
            <div className="certification-card">
              <div className="cert-badge">🇮🇳</div>
              <h3>Made in India</h3>
              <p>Advanced Manufacturing</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <h2>Ready to Experience Premium Quality?</h2>
          <p>Explore our complete product range and find the perfect solution for your needs.</p>
          <a href="/products" className="cta-button">Browse Our Products</a>
        </div>
      </section>
    </main>
  );
};

export default WhyChooseUs;
